export const assetTypeMap = {
    1: "aircraft",
    2: "engine",
    3: "apu",
    4: "landing_gear",
    5: "propeller",
    6: "fan",
    7: "hpc",
    8: "hpt",
    9: "lpt",
    10: "component"
};

export const assetTypeList={
    1: "MSN",
    2: "ESN",
    3: "APU",
    4: "LG",
    5: "Propeller",
    6: "FAN",
    7: "HPC",
    8: "HPT",
    9: "LPT",
    10: "Component"
}

export const typeFieldByAssetType = {
    1: "aircraft_type",
    2: "engine_type",
    3: "apu_type",
    4: "landing_gear_type",
    5: "propeller_type",
    6: "engine_type",
    7: "engine_type",
    8: "engine_type",
    9: "engine_type",
    10: "component_type",
};